import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { COUPON_SET_MEDIUM, COUPON_TYPES, DISPLAY_COUPON_TYPES, WEEKDAY } from 'config/CustomEnums';
import { parseCouponSetOverviewDatetime } from 'models/CouponUtil';

import BaseOverView from './BaseOverview';

import { getReadablePeriod } from 'utils/TimeFormatUtil';

import './CouponTemplateOverview.scss';

function CouponTemplateOverview({ couponSet }) {
  const [mediumTypeDisplay, setMediumTypeDisplay] = useState('Offline only');

  const displayCouponType = DISPLAY_COUPON_TYPES?.[couponSet?.type] || "-"
  const mediumType = couponSet?.mediumType;

  useEffect(() => {
    switch (mediumType) {
      case COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE:
        setMediumTypeDisplay('Online or offline');
        break;
      case COUPON_SET_MEDIUM.ONLINE:
        setMediumTypeDisplay('Online only');
        break;
      case COUPON_SET_MEDIUM.OFFLINE:
      default:
        setMediumTypeDisplay('Offline only');
        break;
    }
  }, [mediumType]);
  const getListStrings = (list, linkPrefix = "", linkText = "View detail", getSubList=()=>{}) => {
    if (list?.length === 0) {
      return null;
    }
    return (
      <ul>
        {list?.map((item) => (
          <li>
            <div>
              {`[ID: ${item.pk}] ${item.name}`}
              {linkPrefix && <Link className="profile-section-link" to={`${linkPrefix}/${item.pk}/`}>{linkText}</Link>}
            </div>
            {getSubList(item)}
          </li>
        ))}
      </ul>
    );
  };

  const titleListA = ['Type','Coupon medium'];
  const valueListA = [displayCouponType, mediumTypeDisplay];
  let titleListB = ['Total Stock', 'Available coupon'];
  let valueListB = [couponSet?.totalNumberOfGeneratedCoupons, couponSet?.stock];
  if (mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE) {
    titleListB = [
      'Total Stock',
      'Total online coupon Stock',
      'Total offline coupon Stock',
      'Available coupon',
      'Available online coupon',
      'Available offline coupon',
    ];
    valueListB = [
      couponSet?.totalNumberOfGeneratedCoupons,
      couponSet?.totalNumberOfGeneratedOnlineCoupons,
      couponSet?.totalNumberOfGeneratedOfflineCoupons,
      couponSet?.stock,
      couponSet?.onlineStock,
      couponSet?.offlineStock,
    ];
  }
  const titleListC = [
    'Linked Campaign',
    'Linked stamp campaign',
    'Linked earning rules',
    'Blackout period (by period)',
    'Blackout period (by weekday)',
  ];
  const valueListC = [
    getListStrings(
      couponSet?.linkedCampaigns,
      '/campaigns',
      'View campaign',
      (campaign)=> (
        <div>
          {getListStrings(campaign?.earningRules, '/earns', 'View earning rule')}
        </div>
      )
    ) || '-',
    getListStrings(couponSet?.linkedStampCampaigns, '/stamp_campaigns', 'View campaign') || '-',
    getListStrings(couponSet?.linkedEarningRules, '/earns', 'View earning rule') || '-',
    couponSet?.validPeriodValues?.length > 0
      ? couponSet?.validPeriodValues?.map((item) =>
          getReadablePeriod(item.startDate, item.endDate, false),
        )
      : '-',
    couponSet?.validWeekday?.length > 0
      ? couponSet?.validWeekday?.map((item) => WEEKDAY[item])
      : '-',
  ];
  const titleList = titleListA.concat(titleListB).concat(titleListC);
  const valueList = valueListA.concat(valueListB).concat(valueListC);

  const generalSectionTitleList = ["Status", "Creation time", "Last modified time", "Last modified by",]
  const generalSectionValueList = [
    couponSet?.status,
    couponSet?.detailDisplayCreationDate || "-",
    couponSet?.detailDisplayLastModifiedDate || "-",
    couponSet?.displayLastModifiedBy || "-",
  ]
  return (
    <>
      <BaseOverView title={"INFORMATION"} itemTitleList={titleList} itemValueList={valueList} />
      <BaseOverView title={"GENERAL"} itemTitleList={generalSectionTitleList} itemValueList={generalSectionValueList} />
    </>
    );
}

export default CouponTemplateOverview;
